import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import { StorageConstants } from '../../constants/Constants';
import { Routes } from '../../constants/RouteConstants';
import CookieHelper from '../../utils/CookieHelper';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Only show cookie consent on web platform
    if (Capacitor.getPlatform() !== 'web') {
      setIsVisible(false);
      return;
    }

    // Transition: Check if it was previously accepted in localStorage
    // This ensures existing users don't see the banner again
    const legacyConsent = localStorage.getItem(StorageConstants.COOKIE_CONSENT);
    const currentConsent = CookieHelper.get(StorageConstants.COOKIE_CONSENT);

    if (currentConsent) {
      setIsVisible(false);
    } else if (legacyConsent) {
      // Migrate legacy consent to cookie
      CookieHelper.set(StorageConstants.COOKIE_CONSENT, legacyConsent);
      localStorage.removeItem(StorageConstants.COOKIE_CONSENT);
      setIsVisible(false);
    } else {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    CookieHelper.set(StorageConstants.COOKIE_CONSENT, 'true');
    setIsVisible(false);
  };

  const handleReject = () => {
    // Even if rejecting non-essential cookies, we store the choice in a cookie
    // so we don't keep asking the user.
    CookieHelper.set(StorageConstants.COOKIE_CONSENT, 'false');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <aside className="cookie-consent-banner fade-in" role="region" aria-label="Cookie Consent">
      <div className="cookie-content">
        <div className="cookie-text">
          <h3>Cookie Consent</h3>
          <p>
            We use cookies to enhance your experience. By clicking "Accept All", you agree to the storing of cookies on your device to enhance site navigation, analyze site usage, and assist in our marketing efforts.
            Learn more in our <Link to={`${Routes?.CmsPages}privacy-policy#Privacy Policy`}>Privacy Policy</Link> and <Link to={`${Routes?.CmsPages}terms-and-conditions#End User License Agreement`}>Terms & Conditions</Link>.
          </p>
        </div>
        <div className="cookie-actions">
          <button className="btn-reject" onClick={handleReject}>
            Necessary Only
          </button>
          <button className="btn-reject" onClick={handleReject}>
            Reject All
          </button>
          <button className="btn-accept" onClick={handleAccept}>
            Accept All
          </button>
        </div>
      </div>
    </aside>
  );
};

export default CookieConsent;
